import emailjs from '@emailjs/browser';

// Initialize EmailJS
emailjs.init("2GG91ZETRouuitGkg");

export const sendShipmentEmail = async (formData) => {
  const templateParams = {
    pickup_location: formData.pickup_location || '',
    dropoff_location: formData.dropoff_location || '',
    book_pick_date: formData.book_pick_date || '',
    email_address: formData.email_address || '',
    phone_number: formData.phone_number || '',
    consent_transactional: formData.consentTransactional ? 'Yes' : 'No',
    consent_marketing: formData.consentMarketing ? 'Yes' : 'No',
    consent_terms: formData.consentTerms ? 'Yes' : 'No',
  };

  try {
    const response = await emailjs.send(
      "service_7dxjt0g",
      "template_0rzmsix",
      templateParams
    );
    return { success: true, response };
  } catch (error) {
    return { success: false, error };
  }
};


